<app-dialog-header [label]="this.label" i18n-label></app-dialog-header>
<app-toolbar>
  <app-tool-button text="Descarregar" (click)="this.downolad(qrImage)" i18n-text color="has-color-green" icon="fa-file-download"></app-tool-button>
</app-toolbar>
<div class="d-flex justify-content-center"><qrcode #qrImage [qrdata]="qrData" [width]="width" [errorCorrectionLevel]="'M'"></qrcode></div>
